export default __webpack_public_path__ + "static/value2-d015666a8d974e9c73a67af99c2b363e.webp";